import { useState, useCallback } from "react";
import { v4 as uuidv4 } from "uuid";
import { useSelector } from "react-redux";

const useHandleFilePath = () => {
	const [filePath, setFilePath] = useState("");
	const [fileType, setFileType] = useState("");
	const contentForm = useSelector((state) => state.contentForm);
	const csvBatchData = useSelector((state) => state.contentForm.csvBatchData);
	const selectedItems = useSelector(
		(state) => state.contentForm.selectedItems
	);

	const sanitizeString = (str) => {
		// Replace any character that isn't a-z, A-Z, 0-9, hyphen, underscore, or period
		return str.replace(/[^a-zA-Z0-9-_.]/g, "");
	};

	const handleSubtitleFilePath = useCallback(
		(type, category, title, language) => {
			return `${sanitizeString(type)}/${sanitizeString(
				category
			)}/${sanitizeString(title).replace(
				/\s+/g,
				""
			)}/subtitles/${sanitizeString(
				title
			).toLowerCase()}-${sanitizeString(language)}.srt`;
		},
		[contentForm, selectedItems]
	);

	const handleFilePath = useCallback(
		(file, title, language = "") => {
			const fileExtension = file.name.split(".").pop().toLowerCase();
			const guid = uuidv4();

			const type = contentForm.contentType;
			const category = contentForm.category;
			let newFilePath;
			if (file?.type === "trailer") {
				newFilePath = `${type.replace(/\s+/g, "")}/${category.replace(
					/\s+/g,
					""
				)}/${title.replace(
					/\s+/g,
					""
				)}/trailer/${guid}.${fileExtension}`;
			} else if (file?.type === "Horizontal Poster") {
				newFilePath = `${type.replace(/\s+/g, "")}/${category.replace(
					/\s+/g,
					""
				)}/${title.replace(
					/\s+/g,
					""
				)}/posters/large/${guid}.${fileExtension}`;
			} else if (file?.type === "Vertical Poster") {
				newFilePath = `${type.replace(/\s+/g, "")}/${category.replace(
					/\s+/g,
					""
				)}/${title.replace(
					/\s+/g,
					""
				)}/posters/default/${guid}.${fileExtension}`;
			} else if (file?.type === "subtitle") {
				newFilePath = `${sanitizeString(type)}/${sanitizeString(
					category
				)}/${sanitizeString(title).replace(
					/\s+/g,
					""
				)}/subtitles/${sanitizeString(
					title
				).toLowerCase()}-${sanitizeString(language)}.srt`;
			} else {
				newFilePath = `${type?.replace(/\s+/g, "")}/${category?.replace(
					/\s+/g,
					""
				)}/${title?.replace(/\s+/g, "")}/${guid}.${fileExtension}`;
			}

			setFilePath(newFilePath);
			setFileType(fileExtension);

			return { filePath: newFilePath, fileType: fileExtension };
		},
		[contentForm, selectedItems]
	);

	return { filePath, fileType, handleFilePath, handleSubtitleFilePath };
};

export default useHandleFilePath;
